import './Suggest.scss';
import Component from './Suggest.js';
export default Component;
